import { connect } from 'react-redux';
import ScribeWelcome from './ScribeWelcome';
import { enableAudioMode, fetchAsyncBackendIfNeeded, fetchAvaWebAppSession, fetchBackendSupport, fetchUserProfile, fetchScribeSettings, firebaseLoginSuccess, getBranchIOData, setElectronAppLoaded, startConversationReadClient, startRecord, initiateSession, toggleDevMode, setAuthenticating, setShowQuickSetup, } from '../../actions';
import { login as accountLogin } from '../../actions/account/session';
const mapStateToProps = (state) => ({
    avaId: state.scribeSession.avaId,
    backendSupport: state.scribeSession.backendSupport,
    branchId: state.scribeSession.branchId,
    backends: state.scribeSession.backends,
    captioner: state.scribeSession.captioner,
    displayable: state.scribeSession.displayable,
    error: state.scribeSession.error,
    features: state.scribeSession.features,
    electronAppLoaded: state.scribeSession.electronAppLoaded,
    scribe: state.scribeConversation.scribe,
    token: state.scribeConversation.token,
    url: state.scribeSession.url,
    needInternalAudioAccess: state.scribeSession.needInternalAudioAccess,
});
export default connect(mapStateToProps, {
    accountLogin,
    enableAudioMode,
    fetchAsyncBackendIfNeeded,
    fetchAvaWebAppSession,
    fetchBackendSupport,
    fetchUserProfile,
    fetchScribeSettings,
    firebaseLoginSuccess,
    getBranchIOData,
    setElectronAppLoaded,
    startConversationReadClient,
    startRecord,
    initiateSession,
    toggleDevMode,
    setAuthenticating,
    setShowQuickSetup,
})(ScribeWelcome);
